import Vue from 'vue';
import store from '@app/store';
import { from, Observable, of } from 'rxjs';
import { fromPromise } from 'rxjs/internal-compatibility';

export default class BPCConfigService extends Vue {
  constructor() {
    super();
  }

  getEntityConfig(config: string, path: string = null) {
    const validConfigSlug = this.formatValidConfigSlug(config);
    return from(store.dispatch('config/getEntityConfig', { config: validConfigSlug, path: path }));
  }

  getEntityTypesConfig(context: string) {
    return from(store.dispatch('config/getEntityTypesConfig', `entityTypes.${context}`));
  }

  formatValidConfigSlug(config: string) {
    const splittedConfig = config.split('.');
    splittedConfig[0] = splittedConfig[0].replace(/-/g, '_');
    return splittedConfig.join('.');
  }
}
